/** Keep the Blob URL alive this long so the browser has started the download before it's released. */
const REVOKE_AFTER_MS = 30_000;

/**
 * Hand a file to the browser as a normal download (a throwaway Blob URL and an
 * anchor click; the add-in has no "Save As" API). The URL is released later
 * rather than straight away, since some browsers cancel a download whose URL
 * is revoked while it is still starting.
 */
export function saveFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.rel = "noopener";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS);
}
